/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * Determines whether the OIDC call should fetch groups data.
 * @export
 */
export const OIDCGroupsOptions = {
    True: 'true',
    False: 'false'
} as const;
export type OIDCGroupsOptions = typeof OIDCGroupsOptions[keyof typeof OIDCGroupsOptions];


export function OIDCGroupsOptionsFromJSON(json: any): OIDCGroupsOptions {
    return OIDCGroupsOptionsFromJSONTyped(json, false);
}

export function OIDCGroupsOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OIDCGroupsOptions {
    return json as OIDCGroupsOptions;
}

export function OIDCGroupsOptionsToJSON(value?: OIDCGroupsOptions | null): any {
    return value as any;
}

